import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, LineChart, Line } from 'recharts';

const ChartCard = ({ 
  icon, 
  title, 
  metricValue, 
  metricPeriod, 
  data, 
  type = 'bar', // 'bar' or 'line'
  colors = ['#e65c00', '#36d576'],
  loading = false,
  stacked = false
}) => {
  const renderChart = () => {
    if (type === 'bar') {
      return (
        <BarChart data={data} margin={{ top: 20, right: 20, left: 20, bottom: 30 }}>
          <XAxis 
            dataKey="day" 
            tick={{ fontSize: 12, fill: '#666' }} 
            axisLine={{ stroke: '#d1d5db', strokeWidth: 1 }} 
            tickLine={{ stroke: '#d1d5db', strokeWidth: 1 }}
          />
          <YAxis 
            tick={{ fontSize: 12, fill: '#666' }} 
            axisLine={{ stroke: '#d1d5db', strokeWidth: 1 }} 
            tickLine={{ stroke: '#d1d5db', strokeWidth: 1 }}
            allowDecimals={false}
          />
          <Tooltip />
          <Bar 
            dataKey="Inbound" 
            stackId={stacked ? "a" : undefined} 
            fill={colors[0]} 
            radius={stacked ? [0, 0, 4, 4] : [4, 4, 4, 4]} 
          />
          <Bar 
            dataKey="Outbound" 
            stackId={stacked ? "a" : undefined} 
            fill={colors[1]} 
            radius={stacked ? [4, 4, 0, 0] : [4, 4, 4, 4]} 
          />
        </BarChart>
      );
    } else {
      return (
        <LineChart data={data} margin={{ top: 20, right: 20, left: 20, bottom: 30 }}>
          <XAxis 
            dataKey="day" 
            tick={{ fontSize: 12, fill: '#666' }} 
            axisLine={{ stroke: '#d1d5db', strokeWidth: 1 }} 
            tickLine={{ stroke: '#d1d5db', strokeWidth: 1 }}
          />
          <YAxis 
            tick={{ fontSize: 12, fill: '#666' }} 
            axisLine={{ stroke: '#d1d5db', strokeWidth: 1 }} 
            tickLine={{ stroke: '#d1d5db', strokeWidth: 1 }}
            allowDecimals={false}
          />
          <Tooltip />
          <Line 
            type="monotone" 
            dataKey="Inbound" 
            stroke={colors[0]} 
            strokeWidth={3}
            dot={false}
            activeDot={{ r: 6 }}
          />
          <Line 
            type="monotone" 
            dataKey="Outbound" 
            stroke={colors[1]} 
            strokeWidth={3}
            dot={false}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      );
    }
  };

  return (
    <div className="analytics-chart-card">
      <div className="analytics-chart-header">
        {icon}
        <div className="analytics-chart-title">{title}</div>
      </div>
      <div className="analytics-chart-metric">
        <div className="analytics-chart-value">
          {loading ? '...' : metricValue}
        </div>
        <div className="analytics-chart-period">{metricPeriod}</div>
      </div>
      <div className="analytics-chart-container">
        <ResponsiveContainer width="100%" height="100%">
          {renderChart()}
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ChartCard;
